/**
 * Hello Couleur — JS du header partagé
 * - Modal de recherche fonctionnelle (loupe)
 * - Burger menu mobile (toggle nav)
 */
(function() {
    // Route de recherche native Shopify (la maquette pointait vers 09_search.html
    // qui n'existe pas sur Shopify → 404). On envoie vers /search?q=...&type=product.
    function searchUrl(q) {
        return '/search?type=product&q=' + encodeURIComponent(q);
    }

    // ============= RECHERCHE =============
    const searchBtns = document.querySelectorAll('.header__action[aria-label="Rechercher"]');
    searchBtns.forEach(btn => {
        btn.addEventListener('click', (e) => {
            e.preventDefault();
            openSearch();
        });
    });

    function openSearch() {
        if (document.getElementById('search-overlay')) return;
        const overlay = document.createElement('div');
        overlay.id = 'search-overlay';
        overlay.innerHTML = `
            <div class="search-overlay__inner">
                <button class="search-overlay__close" aria-label="Fermer">×</button>
                <span class="eyebrow" style="color: var(--c-menthe);">Rechercher</span>
                <h2 style="margin: 8px 0 24px;">Que cherchez-vous ?</h2>
                <form class="search-overlay__form" id="hc-search-form">
                    <input type="search" name="q" id="hc-search-input" placeholder="Carnet, carte, tirage, fleurs…" autofocus required autocomplete="off">
                    <button type="submit" class="btn btn-primary">Rechercher</button>
                </form>
                <div class="search-overlay__suggest">
                    <p style="font-size: 0.8125rem; color: var(--c-crayon); margin: 0 0 12px; text-transform: uppercase; letter-spacing: 0.1em; font-weight: 700;">Recherches populaires</p>
                    <div class="search-overlay__tags">
                        <a href="${searchUrl('anniversaire')}">anniversaire</a>
                        <a href="${searchUrl('guépard')}">guépard</a>
                        <a href="${searchUrl('naissance')}">naissance</a>
                        <a href="${searchUrl('noël')}">noël</a>
                        <a href="${searchUrl('tirage')}">tirage</a>
                        <a href="${searchUrl('pack')}">pack</a>
                        <a href="${searchUrl('frida')}">frida</a>
                    </div>
                </div>
            </div>
        `;
        document.body.appendChild(overlay);
        document.body.style.overflow = 'hidden';

        // Soumission du formulaire → redirige vers 09_search.html?q=...
        overlay.querySelector('#hc-search-form').addEventListener('submit', (e) => {
            e.preventDefault();
            const q = overlay.querySelector('#hc-search-input').value.trim();
            if (q) window.location = searchUrl(q);
        });

        const close = () => { overlay.remove(); document.body.style.overflow = ''; };
        overlay.querySelector('.search-overlay__close').addEventListener('click', close);
        overlay.addEventListener('click', e => { if (e.target === overlay) close(); });
        document.addEventListener('keydown', escHandler);
        function escHandler(e) {
            if (e.key === 'Escape') {
                close();
                document.removeEventListener('keydown', escHandler);
            }
        }
    }

    // ============= BURGER MENU MOBILE =============
    const burger = document.querySelector('.header__burger');
    const nav = document.querySelector('.header__nav');
    if (burger && nav) {
        burger.addEventListener('click', () => {
            nav.classList.toggle('open');
            burger.classList.toggle('open');
        });
    }

    // ============= STYLES INJECTÉS =============
    const style = document.createElement('style');
    style.textContent = `
        #search-overlay {
            position: fixed; inset: 0;
            background: rgba(47, 32, 77, 0.85);
            z-index: 999;
            display: flex;
            align-items: flex-start;
            justify-content: center;
            padding-top: 12vh;
            padding-left: 1rem; padding-right: 1rem;
            animation: fadeIn 0.2s ease;
        }
        @keyframes fadeIn { from { opacity: 0; } to { opacity: 1; } }
        .search-overlay__inner {
            background: white;
            border-radius: 24px;
            padding: 2.5rem;
            max-width: 640px;
            width: 100%;
            position: relative;
            box-shadow: 0 20px 60px rgba(0,0,0,0.3);
        }
        .search-overlay__close {
            position: absolute;
            top: 16px; right: 16px;
            width: 36px; height: 36px;
            border: none; background: var(--c-fleur-de-lait);
            border-radius: 50%;
            font-size: 1.5rem; cursor: pointer;
            display: flex; align-items: center; justify-content: center;
            color: var(--c-nuit-velour); font-weight: 700;
        }
        .search-overlay__close:hover { background: var(--c-galet); }
        .search-overlay__form {
            display: flex; gap: 12px; margin-bottom: 24px;
        }
        .search-overlay__form input {
            flex: 1;
            padding: 14px 20px;
            border: 2px solid var(--c-galet);
            border-radius: 999px;
            font-size: 1.0625rem; font-family: inherit;
            outline: none;
        }
        .search-overlay__form input:focus { border-color: var(--c-menthe); }
        .search-overlay__tags { display: flex; flex-wrap: wrap; gap: 8px; }
        .search-overlay__tags a {
            padding: 6px 14px;
            background: var(--c-fleur-de-lait);
            border-radius: 999px;
            font-size: 0.875rem; font-weight: 600;
            color: var(--c-nuit-velour);
            text-decoration: none;
            transition: background 0.15s;
        }
        .search-overlay__tags a:hover { background: var(--c-eucalyptus); }

        /* Mobile : input + bouton « Rechercher » qui débordaient → empilés en colonne */
        @media (max-width: 600px) {
            #search-overlay { padding-top: 6vh; padding-left: 0.75rem; padding-right: 0.75rem; }
            .search-overlay__inner { padding: 1.5rem; border-radius: 16px; }
            .search-overlay__form { flex-direction: column; gap: 10px; margin-bottom: 20px; }
            .search-overlay__form .btn { width: 100%; }
        }

        /* Burger mobile menu */
        /* Seuil aligne sur design-system.css : a 8 entrees le menu horizontal
           ne tient plus sous 1240px (1400px depuis le 11/10/2026, entrée carte cadeau). */
        @media (max-width: 1400px) {
            .header__nav.open {
                display: flex !important;
                position: absolute;
                top: 100%; left: 0; right: 0;
                background: var(--c-fleur-de-lait);
                flex-direction: column;
                padding: 1rem 1.5rem;
                gap: 0;
                border-top: 1px solid rgba(47,32,77,0.08);
                box-shadow: 0 8px 24px rgba(47,32,77,0.1);
            }
            .header__nav.open a {
                padding: 14px 0;
                border-bottom: 1px solid rgba(47,32,77,0.06);
            }
            .header__nav.open a:last-child { border-bottom: none; }
            .header__burger.open span:nth-child(1) { transform: rotate(45deg) translate(5px, 5px); }
            .header__burger.open span:nth-child(2) { opacity: 0; }
            .header__burger.open span:nth-child(3) { transform: rotate(-45deg) translate(6px, -6px); }
            .header__burger span { transition: transform 0.2s, opacity 0.2s; }
        }
    `;
    document.head.appendChild(style);

    // ============= SYNC BADGE PANIER (panier natif Shopify via /cart.js) =============
    // Le compteur reflete cart.item_count rendu cote serveur ; on le re-confirme
    // via /cart.js (corrige aussi un eventuel cache de section qui afficherait un
    // compte perime). NE PAS lire l'ancien localStorage hc_cart_v1 de la maquette
    // (vide sur Shopify) — c'etait la cause du badge qui retombait a 0.
    function syncCartBadge() {
        const badges = document.querySelectorAll('.header__cart-count');
        if (!badges.length) return;
        fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
            .then(r => r.json())
            .then(c => { badges.forEach(b => { b.textContent = c.item_count; }); })
            .catch(() => {});
    }
    // Expose la fonction globalement pour que les pages produit/panier la rappellent
    window.HC_syncCartBadge = syncCartBadge;
    syncCartBadge();

    // ============= HIGHLIGHT NAV "PAGE ACTIVE" =============
    // Détecte la page courante via le pathname et met le bon lien en couleur menthe.
    function highlightActiveNav() {
        const path = (window.location.pathname.split('/').pop() || '').toLowerCase();
        if (!path) return;
        const navLinks = document.querySelectorAll('.header__nav a');
        navLinks.forEach(a => {
            const href = (a.getAttribute('href') || '').toLowerCase();
            if (!href) return;
            // Match exact
            if (href === path) {
                a.style.color = 'var(--c-menthe)';
                a.setAttribute('aria-current', 'page');
                return;
            }
            // Pages produit individuelles (sous /produits/) → highlight selon le type
            // (déterminé par le fichier de collection le plus pertinent côté nav)
            // Ici on n'applique pas — la page produit n'est pas dans le menu.
        });
        // Cas des pages produits dans /produits/ : pas de match dans la nav. RAS.
        // Cas des pages "secondaires" (12_reseller, 13_pos, 11_florist, 07_contact, 08_faq, 05_cart, 15-18) :
        // pas de match dans la nav → aucun élément highlighté, c'est correct.
    }
    highlightActiveNav();
})();
